import Reports from './Reports/Reports';

export default Reports;
